import { render, staticRenderFns } from "./newMltp.vue?vue&type=template&id=81bd9758&scoped=true"
import script from "./newMltp.vue?vue&type=script&lang=js"
export * from "./newMltp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bd9758",
  null
  
)

export default component.exports